<template>
  <div>
    <vs-popup :title="$t('ModifyCity')" :active.sync="showModal">
      <form>
        <div class="vx-col w-full mt-3">
          <label class="vs-select--label">{{ $t("Province") }}</label>
          <v-select
            label="name"
            :options="allProvince"
            name="province"
            :reduce="(x) => ({ provinceId: x.id, provinceName: x.name })"
            v-validate="{ required: 'true' }"
            ref="provinceListSelect"
            v-model="CityForModify.parentId"
            @input="selectProvince"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <div>
          <vs-input
            class="inputx mb-3 mt-3"
            v-model="CityForModify.name"
            :label="$t('CityName')"
            name="CityName"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('CityName')">{{
            errors.first("CityName")
          }}</span>
        </div>
        <div class="w-full mt-3">
          <vs-input
            class="inputx mb-3"
            v-model="CityForModify.priority"
            :label="$t('Priority')"
            name="priority"
            v-validate="{ required: 'true' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('Priority')">{{
            errors.first("Priority")
          }}</span>
        </div>

        <vs-button
          type="filled"
          class="float-right my-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    CityName: {
      required: "لطفا نام شهر را وارد نمایید.",
    },
    Priority: {
      required: "لطفا اولویت را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "",
  props: {
    show: { default: false },
    CityForModify: {},
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {},
      disabled: false,
    };
  },
  computed: {
    ...mapGetters({
      allProvince: "country/provinceList",
      allCountries: "country/countryList",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("finish");
      },
    },
  },
  mounted() {
    this.fetchProvinces()
  },
  methods: {
    ...mapActions({
      modifyCity: "country/modifyCity",
      fetchProvinces: "country/fetchProvinces",
      fetchProvincesById: "country/fetchProvincesById",
      fetchCountry: "country/fetchCountry",
    }),
    selectProvince(){
      // this.CityForModify.parentId = this.CityForModify.parentId.provinceId;
    },
    submitForm() {
      this.$validator.validateAll().then((r) => {
        if(this.CityForModify.parentId.provinceId){
          this.CityForModify.parentId = this.CityForModify.parentId.provinceId;

        }
        else{
          this.CityForModify.parentId = this.CityForModify.parentId.id;

        }
        if (r) {
          this.modifyCity(this.CityForModify).then(() => {
            this.disabled = false;
            this.$emit("finish");
            this.model = {};
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطا در ثبت مقادیر وارده شده",
            showConfirmButton: false,
            timer: 2000,
          });
        }
      });
    },
  },
};
</script>
